<template class="">
  <section>
    <div v-if="loading" class="content content-centered">
                        <pulse-loader></pulse-loader>
                        <p>Please wait, while map is loading</p>
                    </div>
    <!-- <div v-if="loading" class="loader">
      Loading...
    </div> -->
    <div class="" v-if="!loading">
      <div class="">
        <div class="">
          <div id="details" class="">
            <div class="d-flex flex-column">
            </div>
            <gmap-map
              :center="center"
              :zoom="18"
              map-type-id="terrain"
              style="width: 100%; height: 525px"
            >
                <gmap-marker
                  :clickable ='true'
                  :key="'A'+index"
                  v-for="(gmp, index) in locations"
                  :position="gmp"
                  :icon="gmp.collectedStatus == true ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'"
                  @click="showLocByIndex(index)"
                  @closeclick ="showLocByIndex(null)"
              >
              <gmap-info-window
                  :closeclick ='true'
                  @closeclick ="showLocByIndex(null)"
                  :opened="showByIndex === index"
              >
                  <div class="houseInfo">
                    <div v-if="gmp.houseImage != 'null'" class="houseImg"><img :src="gmp.houseImage"/></div>
                    <div class="mt-10" v-if="gmp.hasOwnProperty('hnNo')"><span class="houses">{{gmp.hnNo}} ({{ gmp.lineTowerName}})</span></div>
                    <div class="mt-10" v-if="gmp.hasOwnProperty('houseNo')"><span class="houses">{{gmp.houseNo}} ({{gmp.name}})</span></div>
                    <div v-if="gmp.hasOwnProperty('memberCount')"><span style="font-size:12px;font-weight:550">Members: </span><span>{{gmp.memberCount}}</span></div>
                    <!-- <div v-if="gmp.hasOwnProperty('houseStatus')"><span>{{gmp.houseStatus}}</span></div>
                    <div v-if="gmp.hasOwnProperty('surveyorName')"><span>{{gmp.surveyorName}}</span></div>
                    <div v-if="gmp.hasOwnProperty('surveyStatus')"><span>{{gmp.surveyStatus}}</span></div> -->
                  </div>
              </gmap-info-window>
              </gmap-marker>
            </gmap-map>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { eventBus } from "../../../services";

export default {
  name: "multiLocation",
  props: ["user"],
  data() {
    return {
      loading:true,
        center: { 
          lat: 28.7041, 
          lng: 77.1025
            },
        locations: [],
        currentLocation: null,
        showByIndex:null,
    };
  },
  // mounted () {
  //       eventBus.$on("housesLocation", (location) => {
  //       this.setLocationLatLng(location)
  //       this.center= {
  //         lat: location[0].lat,
  //         lng: location[0].lng
  //           }
  //   });
  // },

  methods: {
    setLocationLatLng: function(houses) {
        navigator.geolocation.getCurrentPosition(geolocation => {
          this.loading = false
          // this.center = {
          //   lat: geolocation.coords.latitude,
          //   lng: geolocation.coords.longitude
          // };
        });
        this.locations = [...houses];
        // this.locations = [
        //     {
        //       lat: 28.6083167,
        //       lng: 77.3718114,
        //       label: 'uuuuuuu'
        //   },
        //   {
        //       lat: 28.6083157,
        //       lng: 77.3718104,
        //       label: 'ssssss'
        //   },
        // ]
    },

    showLocByIndex(index){
      this.showByIndex = index
    }
  },

  mounted() {
    eventBus.$off('housesLocation');
        eventBus.$on("housesLocation", (location, calledFrom) => {
        this.setLocationLatLng(location)
        this.center= {
          lat: location[0].lat,
          lng: location[0].lng
        }
      });
      
      if(this.user == 'SurveyDetailsMap'){
        eventBus.$emit("houseSurveyEvent", {});   
      } else {
        eventBus.$emit("houseZoneEvent", {});
      }
  },
  beforeDestroy() {
    eventBus.$off('housesLocation');
  },
};

</script>
<style scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  /* Adjust the z-index based on your layout */
  z-index: 9999;
}
.houses{
  font-size: 15px;
  font-weight: 550;
}
</style>



// WEBPACK FOOTER //
// multiLocation.vue?fce51e9c